// whatever we want to test here for touch devices
const isTouchDevice = () => window.matchMedia('(pointer: coarse)').matches;

/**
 * Is this a touch device and smaller than mobile-breakpoint-max?
 * @param testTouch Inlcude testing for touch
 * @return Is mobile
 */
export const isMobile = (testTocuh = true) =>
	(!testTocuh || isTouchDevice()) && window.innerWidth < 767;

export default isMobile;
